import _ from 'lodash';
import { observable, computed, makeObservable } from 'mobx';
import {DomainObject} from 'shared/store';
import CustomField from './CustomField';

class CustomFieldGroup extends DomainObject {
  id;
  name;
  order;
  category;
  customFields = [];
  employeeCustomFields = [];

  _relations = {
    customFields: [CustomField]
  };

  constructor(other) {
    super();

    makeObservable(this, {
      id: observable,
      name: observable,
      order: observable,
      category: observable,
      customFields: observable,
      employeeCustomFields: observable,
      sortedCustomFields: computed,
      sortedEmployeeCustomFields: computed
    });

    this.merge(other);
  }

  get sortedCustomFields() {
    return _.sortBy(this.customFields, ['order']);
  }

  get sortedEmployeeCustomFields() {
    return _.sortBy(this.employeeCustomFields, ['order']);
  }
}

export default CustomFieldGroup;
